<template>
  <div class="toolbar-icon" :title="$t('title.deleteComment')" @click="removeComment">
    <custom-icon :class-name="icons.DeleteComment" />
  </div>
</template>
<script>
import { icons } from "../../../utils/icons";
import CustomIcon from "../../commons/CustomIcon.vue";
import DesignerMixin from "../DesignerMixin";

export default {
  components: { CustomIcon },
  mixins: [DesignerMixin],
  data() {
    return {
      icons: icons,
    };
  },
  methods: {
    removeComment() {
      this.$store.dispatch("cells/removeComment");
    },
    callFunc() {
      this.removeComment();
    },
  },
};
</script>
